<template>
  <!-- <div v-if="type == 1" class="button" @click="handleClick">
    {{ value }}
  </div> -->

  <el-button
    v-if="type == 1"
    class="button blue-bt1"
    :size="size"
    @click="handleClick"
    :icon="icon"
    >{{ value }}</el-button
  >
  <el-button
    v-else-if="type == 2"
    class="button blue-bt2"
    :size="size"
    @click="handleClick"
    >{{ value }}</el-button
  >
  <el-button
    v-else-if="type == 3"
    class="button blue-bt3"
    :size="size"
    @click="handleClick"
    >{{ value }}
  </el-button>
  <el-button
    v-else-if="type == 4"
    class="button blue-bt4"
    :size="size"
    @click="handleClick"
    :icon="icon"
    >{{ value }}</el-button
  >

  <el-button
    v-else-if="type == 5"
    class="button blue-bt2"
    :size="size"
    @click="handleClick"
    >{{ value }} <i class="el-icon-warning-outline"></i
  ></el-button>
</template>

<script>
export default {
  name: "MyButton",
  data() {
    return {};
  },
  props: {
    type: String,
    value: String,
    size: String,
    icon: String,
  },

  methods: {
    handleClick(event) {
      this.$emit("click", event);
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  // display: inline-block;
  // padding: 8px 15px;
  // font-size: 12px;
  // border-radius: 3px;
  // background: linear-gradient(234deg, #9583ff 0%, #7057ff 100%);
  cursor: pointer;
  color: #fff;
  transition: 0.1s;
  font-weight: 500;
}
.button:hover {
  // background: linear-gradient(234deg, #9583ff 0%, #846ffd 100%);
  // opacity: 0.9;
}
.el-button:active {
  color: #fff;
}

.blue-bt1 {
  background: linear-gradient(234deg, #9583ff 0%, #7057ff 100%);
  border-color: #9583ff;
  opacity: 1;
  padding: 14px 20px;
}
.blue-bt1:active {
  //   background: #9583ff;
  //   border-color: #9583ff;
  //   color: #fff;
  background: #9583ff;
}
.blue-bt1:hover {
  // background: #9583ff;
  // border-color: #9583ff;
  // color: #fff;
}
.blue-bt2 {
  border: 1px solid #9583ff;
  border-radius: 3px;
  color: #9583ff;
  padding: 14px 20px;
}
.blue-bt2:active {
  background: #7057ff;
  border-color: #7057ff;
  color: #fff;
}
.blue-bt2:hover {
  background: #9583ff;
  border-color: #9583ff;
  color: #fff;
}
.blue-bt3 {
  background: #00c793;
  border-color: #00c793;
  padding: 14px 20px;
}

.blue-bt4 {
  background: linear-gradient(234deg, #ff6157 0%, #ff418a 100%);
  border-color: #ff6157;
  color: #fff;
  padding: 14px 20px;
}
</style>
